const logInfo = (value: string, data?: any) => {
  const text = `[@dustin/auth-js ${new Date().toISOString()}] ${value}`

  if (data) console.info(text, data)
  else console.info(text)
}

const logError = (value: string, error: any) => {
  const text = `[@dustin/auth-js ${new Date().toISOString()}] ${value}`

  if (error) console.error(text, error)
  else console.error(text)
}

export default (debug: boolean) => {
  return {
    info: (value: string, data?: any) => debug && logInfo(value, data),
    error: (value: string, error?: any) => logError(value, error),
  }
}
